import { get, set } from "idb-keyval";
import Papa from "papaparse";
import { BASE_URL } from "../constants";
import { getAuthHeader } from "../utils";
import { UserRole } from "../constants"; 

/**
 * Calcula el timestamp del próximo domingo a las 00:00
 */
function getNextSundayTimestamp() {

  const now = new Date();
  const dayOfWeek = now.getDay();
  const daysUntilSunday = (7 - dayOfWeek) % 7;
  const nextSunday = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() + daysUntilSunday,
    0, 0, 0, 0
  );
  
  return nextSunday.getTime();
}

/**
 * Obtiene los diagnósticos, usando IndexedDB como caché semanal.
 * @returns {Promise<Array<{id: number, name: string, code: string}>>}
 */
export async function getCachedDiagnosisList() {
  try {
    const cacheKey = "diagnosisList";
    const cacheMetaKey = "diagnosisListMeta";
    const cached = await get(cacheKey);
    const meta = await get(cacheMetaKey);

    const now = Date.now();
    let mapped;

    if (cached && meta && meta.expiry > now) {
      mapped = cached;
    } else {
      const response = await fetch(`${BASE_URL}insurance/export-csv-diagnosis/`, {
        headers: {
          ...getAuthHeader(),
        },
      });

      if (!response.ok) throw new Error("No se pudo descargar el CSV de diagnósticos");
      const csvText = await response.text();

      const { data } = Papa.parse(csvText, { header: true, skipEmptyLines: true });

      mapped = data.map((item, idx) => ({
        id: item.id || idx,
        name: `${item.code} - ${item.name}`,
        code: item.code,
        rawName: item.name,
      }));

      await set(cacheKey, mapped);
      await set(cacheMetaKey, { expiry: getNextSundayTimestamp() });
    }

    // Filtrar según el rol
    const role = localStorage.getItem("role");
    if (role !== UserRole.LABORATORY) {
      mapped = mapped.filter((item) => item.code !== "0000");
    }

    return mapped;

  } catch (error) {
    console.error("Error fetching diagnosis list: ", error);
    return [];
  }
}